import { TooltipProps } from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";

import {
  TooltipDot,
  TooltipLabel,
  TooltipRow,
  TooltipWrapper,
} from "./DashboardTooltip.styles";

interface IDashboardTooltipProps extends TooltipProps<ValueType, NameType> {
  valueSuffix?: string;
  valueLabel?: string;
}

export function DashboardTooltip({
  active,
  payload,
  label,
  valueSuffix = "",
  valueLabel,
}: IDashboardTooltipProps) {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <TooltipWrapper>
      {label !== undefined && <TooltipLabel>{label}</TooltipLabel>}
      {payload.map((entry, idx) => (
        <TooltipRow key={`${entry.dataKey}-${idx}`}>
          <TooltipDot style={{ backgroundColor: entry.color ?? "#7562A8" }} />
          <span>
            {valueLabel ?? entry.name}:{" "}
            <strong>
              {entry.value}
              {valueSuffix}
            </strong>
          </span>
        </TooltipRow>
      ))}
    </TooltipWrapper>
  );
}
